import React from "react";
import Hero from "../components/home/Hero";
import StatsBar from "../components/home/StatsBar";
import TrustStrip from "../components/home/TrustStrip";
import AboutSection from "../components/home/AboutSection";
import WhyChoose from "../components/home/WhyChoose";
import Services from "../components/home/Services";
import HowToStart from "../components/home/HowToStart";
import Exchanges from "../components/home/Exchanges";
import ProcessSection from "../components/home/ProcessSection";
import Founder from "../components/home/Founder";
import FAQSection from "../components/home/FAQSection";
import CTASection from "../components/home/CTASection";
import CmsContent from "../components/CmsContent";

const Home = () => {
  return (
    <main>
      <Hero />
      <StatsBar />
      <AboutSection />
      <WhyChoose />
      <TrustStrip />
      <Services />
      <HowToStart />
      <Exchanges />
      <ProcessSection />
      <Founder />
      <FAQSection />
      <CTASection />
      <CmsContent slug="home" fallbackTitle="Online Cricket ID (2026) with DaddyAnna" showContent={false} />
    </main>
  );
};

export default Home;
